module.exports = __webpack_public_path__ + "img/logo.f14383dc.png";